module.exports = __webpack_public_path__ + "static/Auto-Share-3-e1407759014303-2fc3b572a86fea4a67f24ba7d5f40313.jpg";